import React from "react";

const GettingStartedComponent = () => {
    return (
        <article className="docs-article" id="section-2">
            <header className="docs-header">
                <h1 className="docs-heading">Getting Started <span className="docs-time">Last updated: 2023-06-30</span>
                </h1>
                <section className="docs-intro">
                    <p>New merchants are required to request a merchant API access token. This token serves as your access key to try out our APIs in the respective development environments.</p>
                    <p>To obtain your merchant API access token, please reach out to Westpay AB and provide the necessary details. Our team will assist you in acquiring the access token promptly, enabling you to proceed with your integration.
                        Once you have your API access token, you can start testing and experimenting with our APIs using our Swagger endpoint. Swagger provides a user-friendly interface where you can make API calls, explore different endpoints, and assess their functionality.</p>
                    <p>Feel free to dive into our APIs using the provided access token and the Swagger endpoint. Begin your journey towards seamless integration and unlock the potential of Westpay AB's innovative payment solutions.</p>
                </section>
            </header>
        </article>
    )
}

export default GettingStartedComponent;